import { createAsyncThunk } from "@reduxjs/toolkit";
import { STATION_DEVICES } from "../../../API/UserApi";

import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const deleteStationDeviceAPI: any = createAsyncThunk(
  "deleteStationDevice",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.delete(STATION_DEVICES + "/" + rowId, {
        headers: commonHead,
      });
      return { stationDeleted: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
